import React from 'react'
import {AppBar,Toolbar,styled,Box} from '@mui/material'
import LogindilogBox from './account/LogindilogBox'
import ChatDilog from './chat/ChatDilog'
import { useChatContex } from '../contex/ChatContex'


const Container=styled(Box)`
height:100vh;
background:#DCDCDC;
`

const LoginHeader=styled(AppBar)`
height:220px;
background-color:#00bfa5;
box-shadow:none;
`

const Header=styled(AppBar)`
height:125px;
background-color:#00bfa5;
box-shadow:none;
`



function Messanger() {

 
const {login}=useChatContex()


    return (
        <Container>
        {
            login ?<>
            <Header>
                <Toolbar>
                    
                </Toolbar>
            </Header>
            <ChatDilog/>
            </> 

            :<>
            <LoginHeader>
                <Toolbar>

                </Toolbar>
            </LoginHeader>
            <LogindilogBox/>

            </>
        }  
        </Container>
    )
}

export default Messanger
